import { isHqAuthenticated } from "@/hq/hq-auth";
import { Navigate, Outlet } from "react-router";

export function HqAuthGuard() {
  if (!isHqAuthenticated()) {
    return <Navigate to="/hq/login" replace />;
  }

  return <Outlet />;
}
